export default {
  service(state) {
    return state.service
  },
  services(state) {
    return state.services
  },
  serviceForm(state) {
    return state.serviceForm
  },
  serviceErrors(state) {
    return state.serviceErrors
  },
  serviceFilters(state) {
    return state.serviceFilters
  },
  servicePriceIntervalsAdded(state) {
    return state.servicePriceIntervalsAdded
  },
  servicePriceIntervalsRemoved(state) {
    return state.servicePriceIntervalsRemoved
  },
  servicePriceIntervalsAddedMarkedForRemoval(state) {
    return state.servicePriceIntervalsAddedMarkedForRemoval
  },
}
